import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Icon } from '@node-space/ui-components'

export interface LoadingIndicatorProps {
  text?: string
  testId?: string
}

export const LoadingIndicator = ({ text, testId = 'loading-indicator' }: LoadingIndicatorProps) => {
  const { t } = useTranslation()

  return (
    <Box flex align="center" gap={4} testId={testId}>
      <Box
        flex
        align="center"
        testId={testId ? `${testId}-spinner` : undefined}
        className="animate-spin"
      >
        <Icon name="Spinner" size="medium" />
      </Box>
      <Box className="text-foreground-subdued text-body-regular">
        {text ?? t('earn.calculatingEllipses')}
      </Box>
    </Box>
  )
}
